import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, Divider, FormControlLabel, FormGroup, Grid, Hidden, SelectChangeEvent, Skeleton, Theme, Typography, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootStateType } from '../../../redux-store/reducers';
import BreadCrum from '../../../lib/BreadCrum';
import { getMandateCreationDetails, getMandatesList, setAppliedFundsFilters, setCheckedHoldingSchemes, setSelectedAllHoldingsInfo, setSelectedHoldingsIds, setSelectedHoldingsInfo, setSelectedSchemesObj } from '../../../redux-store/actions/investorProfile';
import HoldingFundMore from '../common/HoldingFundMore';
import MoreFundsModal from '../common/MoreFundsModal';
import { HoldingsTableData } from '../mutualFund/holdings/types';
import ConfirmRecomment from '../common/ConfirmRecomment';
import RiskProfilePopup from '../common/RiskProfilePopup';
import AddtoCardPopup from '../common/AddtoCardPopup';
import SuccessModal from '../common/SuccessModal';
import FiveSchemeErrorMessage from '../mutualFund/common/FiveSchemeErrorMessage';
import ValidateDialogBox from '../mutualFund/common/ValidateDialogBox';
import { applicantStatusMasters, COMMON_EDIT, ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MAX_SCHEMES_SELECTED, MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES } from '../../../utils/constant';
import { FieldArray, Form, Formik, FormikProps, FormikValues } from 'formik';
import { BluePlusIcon, CheckIcon, EmailIcon, FailureIcon, Phoneicon, UnCheckIcon } from '../../../assets/SvgIcons';
import { findNextValidDate, formatCurrency, getAbbreviatedName, isOnboardingTypeMinor, maskInfo, toINR , isRMLikeRole } from '../../../utils/utilityFunctions';
import { GETINVESTMENTDETAILTYPE, GetInvestmentUserDetails } from '../../../redux-store/types/api-types';
import { getInvestmentDetails, getInvestmentUserDetails, getRiskProfileCheck, submitInvestmentDetails, submitRecomment } from '../../../redux-store/actions/funds';
import { MandateCreation, MandateListItem, MandatesListResBody } from '../../../redux-store/types/investorProfile';
import Card from './Card';
import * as Yup from 'yup';
import { MpowerValidationType } from '../types';
import dayjs from 'dayjs';
import { addToCart, getCartItemsCount, setCartItemsCount } from '../../../redux-store/actions/cart';
import { AddToCartResponseBody, GetCartItemsCountResponseBody } from '../../../redux-store/types/cart';
import { handleDateValidation } from './Sip';
import TransactionsDocumentUpload from '../../../lib/TransactionsDocumentUpload';
import { BankDetails, GetBankBalanceResponseBody, GetOrderEntryBanksListResponseBody } from '../../../redux-store/types/orderManagement';
import { getBankBalance, getOrderEntryBanksList } from '../../../redux-store/actions/orderManagement';
import { CustomeBlueDropDown } from './FromInput';
import { CustomeButton } from '../../../lib/formik/NewFormInputs';
import { showError } from '../../../redux-store/actions/auth';
import { TransactionsDisclaimer, TransactionsDisclaimerText } from '../../ApplicationDetails/TermsAndConditions';


const initialData = {
    fund: [
        {
            sip: {
                sipamount: '25000',
                periods: '',
                installments: '',
                // sipDate: dayjs().add(1, 'day').format("YYYY-MM-DD"),
                sipDate: '',
                mandate: {
                    mandateId: "",
                    amount: '100000',
                    accountNo: '',
                    ifscCode: '',
                    bankName: '',
                    startDate: dayjs().format("YYYY-MM-DD"),
                    endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                    curMandateStatus: "",
                },
                sipFolio: '',
                firstOrder: false,
                curMandateStatus: "",
                pending: {
                    amount: '100000',
                    accountNo: '',
                    ifscCode: '',
                    bankName: '',
                    startDate: dayjs().format("YYYY-MM-DD"),
                    endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                    acctType: ""
                },
                active: {
                    mandateId: '',
                },
                freshMandatePayload: {},
                sipEndDate: '',
                // curMandateStatus: '',
                // mandateCreationDate: '',
            },
            lumpsum: {
                lumpAmount: '50000',
                lumpsumFolio: '',
            },
            lumpsumSip: {
                lumpSumAmount: '',
                sipAmount: '',
                periods: '',
                installments: '',
                sipDate: '',
                mandate: '',
                sipFolio: '',
            },
            activeTab: 'Lumpsum',
        },

    ]
}




const Transaction = () => {
    const { palette, typography } = useTheme();
    const history = useHistory();
    const { pathname, state } = history.location;

    const { comingFrom = "", sipAmount = "", selectedCategory = "" } = state as { comingFrom?: string, sipAmount?: string, selectedCategory?: string };

    const isComingFromIndFund = comingFrom?.toLowerCase() === 'individualfund';
    const dispatch = useDispatch();
    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);

    const {
        selectedSchemesObj = {},
        selectedHoldingsIds,
        selectAllHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);
    const {
        selectedPortfolio,
        selectedPortfolioObj
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    const { iwappRmId = "", clientInterfaceCode, familyMemberId = "" } = useSelector((store: RootStateType) => store.id)
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData)
    const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);

    const {
        selectedSchemes = [],
        clientCode,
        folio = [],
        schemeDetails = [],
        fund: stateFund = []
    } = (state as {
        selectedSchemes?: any[],
        clientCode: string,
        folio?: {
            folioId?: string,
            schemeId?: string,
            marketValue: number,
            investedValue: number,
            id: string
        }[],
        schemeDetails?: {
            scheme_id: string,
            isReinvestment: string
        }[],
        fund?: any[];
    }) ?? []

    const [schemeAllDetails, setSchemeAllDetails] = useState<Array<{ scheme_id: string, isReinvestment: string }>>(schemeDetails);

    const formRef = useRef<FormikProps<FormikValues>>(null);

    //state
    const [open, setOpen] = useState(false);
    const [holdingsData, setHoldingsData] = useState<HoldingsTableData[]>([])
    const [apiLoading, setApiLoading] = useState(false);
    const [confirmRecomment, setConfirmRecomment] = useState(false);
    const [orderType, setOrderType] = useState<'order' | 'recomment' | 'investor'>('order');
    const [riskProfilePopup, setRiskProfilePopup] = useState<boolean>(false);
    const [riskPopupText, setRiskPopupText] = useState<string>('');
    const [cartPopup, setCartPopup] = useState<boolean>(false);
    const [isFiveSchemesDialogVisible, setFiveSchemesDialogVisible] = useState<boolean>(false)
    const [isValidationDialogVisible, setValidationDialogVisible] = useState<boolean>(false)
    const [validationErrorsArray, setValidationErrorsArray] = useState<{ schemeName: string; errorMessage: string }[]>([])
    const [riskPflChkLoading, setRiskPflChkLoading] = useState<boolean>(false);
    const [successModal, setSuccessModal] = useState(false);
    const [userLoading, setUserLoading] = useState(false);
    const [userDetails, setUserDetails] = useState<GetInvestmentUserDetails>({} as GetInvestmentUserDetails);
    const [isLoading, setIsLoading] = useState(true);
    const [details, setDetails] = useState<GETINVESTMENTDETAILTYPE>({} as GETINVESTMENTDETAILTYPE);
    const [activeMandateList, setActiveMandateList] = useState<MandateListItem[]>([]);
    const [formInitialData, setFormInitialData] = useState(initialData);
    const [isDocumentUploadDialogVisible, setDocumentUploadDialogVisible] = useState<boolean>(false);
    const [isDocumentUploadErrorDialogVisible, setDocumentUploadErrorDialogVisible] = useState<boolean>(false);
    const [recommendPlaceOrderResponse, setRecommendPlaceOrderResponse] = useState<any>({})
    const [bankAccountList, setBankAccountList] = useState<GetOrderEntryBanksListResponseBody>({} as GetOrderEntryBanksListResponseBody)
    const [isBankBalanceObjLoading, setBankBalanceObjLoading] = useState<boolean>(false)
    const [bankBalanceObj, setBankBalanceObj] = useState<GetBankBalanceResponseBody>({} as GetBankBalanceResponseBody)
    const [isSameSchemesDialogOpen, setSameSchemesDialogOpen] = useState<boolean>(false)
    const [mandatesListRes, setActiveManListRes] = useState<MandatesListResBody>({} as MandatesListResBody);
    const [banksList, setBanksList] = useState<Array<MandateCreation>>([]);

    //AddMore fund Model
    const [radioValue, setRadioValue] = useState<any[]>([]);
    const [warning, setWarning] = useState<boolean>(false);

    const [disclaimerChecked, setDisclaimerChecked] = useState<boolean>(false);
    const [isTxnDialog, setIsTxnDialog] = useState<boolean>(false);

    const isInvestMore = pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'

    const investmentDetailsSchema = Yup.object().shape({
        fund: Yup.lazy((_value) => {
            const getValidation = (index: number, type: "SUB" | "RED" | "SIP" | "STP" | "SWP"): MpowerValidationType => {
                const validationData = _value[index]?.validations?.filter((item: MpowerValidationType) => item?.transactionType === type)[0] ?? {}
                return validationData
            }
            const getDateValidation = (index: number, type: "SUB" | "RED" | "SIP" | "STP" | "SWP", period: string): MpowerValidationType => {
                const validationData = _value[index]?.validations?.filter((item: MpowerValidationType) => item?.transactionType === type && item.frequency === period)[0] ?? {}
                return validationData
            }
            return Yup.array().of(
                Yup.object().shape({
                    sip: Yup.object().nullable().default(null).when('activeTab', {
                        is: 'SIP',
                        then: Yup.object().shape({
                            sipamount: Yup.number().required('SIP Amount is Required').positive('Amount must be greater than zero').test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                // const validationData = getValidation(index, 'SIP')
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                return Number(value) >= (validationData?.minimumInstallmentAmount || 0) ? true : createError({ path, message: `Minimum amount is ${validationData?.minimumInstallmentAmount}` });
                            }),
                            periods: Yup.string().required('Frequency is Required'),
                            installments: Yup.number().test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                // const validationData = getValidation(index, 'SIP')
                                if (`${parent?.periods ?? ""}`.toUpperCase() === 'DAILY') {
                                    return true;
                                }

                                if (!`${value ?? ""}`.length) {
                                    return createError({ path, message: 'Installment is Required' })
                                }
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                return Number(value) >= (validationData?.minimumInstallments || 0) ? true : createError({ path, message: `Minimum installments is ${validationData?.minimumInstallments}` });
                            }),
                            // sipDate: Yup.date().nullable().typeError('Invalid Date').required('SIP Date is Required').test('validations', '', function (value, context) {
                            //     const { parent, createError, path } = context;
                            //     console.log('context',context);
                            //     const index = Number(path.match(/[\d,]+/g)?.[0])
                            //     const validationData = getDateValidation(index, 'SIP', parent?.periods)
                            //     // For past date
                            //     if ((dayjs(new Date()).isAfter(value, 'day'))) {
                            //         return createError({ path, message: 'Past date is not allowed' });
                            //     }
                            //     // For T+1 date
                            //     if ((dayjs(new Date()).add(1, 'day').isAfter(value, 'day'))) {
                            //         return createError({ path, message: 'Date should be T+1' });
                            //     }
                            //     const valid = handleDateValidation(validationData?.investmentDates, dayjs(value))
                            //     if (valid) {
                            //         return createError({
                            //             message: `Only ${validationData?.investmentDates.join(', ')} are allowed`,
                            //             path
                            //         })
                            //     }
                            //     return true
                            // }),
                            sipDate: Yup.date()
                                .nullable()
                                .typeError('Invalid Date')
                                // .required('SIP Date is Required')
                                .test('validations', '', function (value, context) {
                                    const { parent, createError, path } = context;
                                    const index = Number(path.match(/[\d,]+/g)?.[0]);

                                    const validationData = getDateValidation(index, 'SIP', parent?.periods);
                                    const today = dayjs();
                                    const sipDate = dayjs(value);

                                    // const dow = sipDate.day(); // 0=Sun,6=Sat
                                    // if (dow === 0 || dow === 6) {
                                    //     return createError({ path, message: 'Weekends (Sat/Sun) are not allowed' });
                                    // }

                                    // if (!validationData?.investmentDates?.length) {
                                    //     return createError({ path, message: 'No valid SIP dates configured.' });
                                    // }

                                    const validInvestmentDates = validationData.investmentDates;
                                    const nextValidDate = findNextValidDate(validInvestmentDates, 'active', !!parent?.firstOrder, parent?.periods);

                                    if (!value) {
                                        return createError({ path, message: `SIP ${parent?.periods === 'DAILY' ? "Start" : ""} Date is Required` });
                                    }

                                    // If mandate is active
                                    if (parent?.curMandateStatus === 'active') {
                                        if (today.isAfter(sipDate, 'day')) {
                                            return createError({ path, message: 'Past date is not allowed' });
                                        }

                                        if (today.add(2, 'days').isAfter(sipDate, 'day')) {
                                            return createError({ path, message: 'Date should be T+2' });
                                        }
                                    }

                                    // else part is for if mandate is not active
                                    if (sipDate.isBefore(nextValidDate, 'day')) {
                                        return createError({ path, message: `Date should be ${nextValidDate?.format('DD/MM/YYYY')} and onwards` });
                                    }

                                    const invalid = handleDateValidation(validInvestmentDates, sipDate);
                                    if (invalid) {
                                        return createError({
                                            path,
                                            message: `Only ${validInvestmentDates.join(', ')} are allowed`,
                                        });
                                    }

                                    return true;
                                }),
                            // mandate: Yup.string().required('Mandate is Required'),
                            mandate: Yup.object()
                                .nullable()
                                .test(
                                    'mandate-complete',
                                    'Mandate is Required',
                                    function (value) {
                                        return (
                                            value !== null &&
                                            typeof value === 'object' &&
                                            value.accountNo &&
                                            value.bankName
                                        );
                                    }
                                ),
                            ...(isInvestMore ? {} : {
                                sipFolio: Yup.string().required('Required'),
                            }),
                            sipEndDate: Yup
                                .date()
                                .nullable()
                                .typeError('Invalid Date')
                                .test('sip-end-date-check', (value, context) => {
                                    const { parent, path, createError } = context;
                                    console.log('parent', parent, path);

                                    if (parent?.periods === 'DAILY') {
                                        if (!value) {
                                            return createError({
                                                message: 'SIP End Date is Required',
                                                path,
                                            });
                                        }
                                        if (parent?.sipDate && value && dayjs(value)?.isBefore(dayjs(parent?.sipDate), 'day')) {
                                            return createError({
                                                message: 'End date should be greater than or equal to start date',
                                                path
                                            })
                                        }

                                        return true
                                    }
                                    return true
                                })
                        }),
                        otherwise: Yup.object().shape({
                            sipamount: Yup.number().notRequired(),
                            periods: Yup.string().notRequired(),
                            installments: Yup.number().notRequired(),
                            sipDate: Yup.date().notRequired(),
                            sipEndDate: Yup.date().notRequired(),
                            mandate: Yup.object().notRequired(),
                            sipFolio: Yup.string().notRequired(),
                        })
                    }),
                    lumpsum: Yup.object().nullable().default(null).when('activeTab', {
                        is: 'Lumpsum',
                        then: Yup.object().shape({
                            lumpAmount: Yup.number().required('Lumpsum Amount is Required')
                                .positive('Amount must be greater than zero')
                                .test('validations', '', function (value, context) {
                                    const { parent, createError, path } = context;
                                    const index = Number(path.match(/[\d,]+/g)?.[0])
                                    const validationData = getValidation(index, 'SUB')

                                    const isNewFolioSelected = `${parent?.lumpsumFolio ?? ""}`?.toLowerCase() === "new folio"

                                    let minLumpsumAmount = validationData?.minimumInstallmentAmount ?? 0

                                    if (isInvestMore || (!isInvestMore && !isNewFolioSelected)) {
                                        minLumpsumAmount = validationData?.addtionalMinimumPurchaseAmpunt ?? 0;
                                    }

                                    return Number(value) >= (minLumpsumAmount || 0) ? true : createError({ path, message: `Minimum amount is ${String.fromCharCode(parseInt(currencySymbol, 16))} ${minLumpsumAmount}` });
                                }),
                            ...(isInvestMore ? {} : {
                                lumpsumFolio: Yup.string().required('Folio is Required'),
                            }),
                        }),
                        otherwise: Yup.object().shape({
                            lumpAmount: Yup.number().notRequired(),
                            lumpsumFolio: Yup.string().notRequired(),
                        })
                    }),
                    lumpsumSip: Yup.object().nullable().default(null).when('activeTab', {
                        is: "Lumpsum + SIP",
                        then: Yup.object().shape({
                            lumpSumAmount: Yup.number().required('Lumpsum Amount is Required').positive('Amount must be greater than zero').test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                // const validationData = getValidation(index, 'SIP')
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                return Number(value) >= (validationData?.minimumInstallmentAmount || 0) ? true : createError({ path, message: `Minimum amount is ${validationData?.minimumInstallmentAmount}` });
                            }),
                            sipAmount: Yup.number().required('SIP Amount is Required').positive('Amount must be greater than zero').test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                // const validationData = getValidation(index, 'SIP')
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                return Number(value) >= (validationData?.minimumInstallmentAmount || 0) ? true : createError({ path, message: `Minimum amount is ${validationData?.minimumInstallmentAmount}` });
                            }),
                            periods: Yup.string().required('Frequency is Required'),
                            installments: Yup.number().required('Installments is Required').positive('Amount must be greater than zero').test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                // const validationData = getValidation(index, 'SIP')
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                return Number(value) >= (validationData?.minimumInstallments || 0) ? true : createError({ path, message: `Minimum installments is ${validationData?.minimumInstallments}` });
                            }),
                            sipDate: Yup.date().nullable().typeError('Invalid Date').required('SIP Date is Required').test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                // For past date
                                if ((dayjs(new Date()).isAfter(value, 'day'))) {
                                    return createError({ path, message: 'Past date is not allowed' });
                                }
                                // For T+2 date
                                if ((dayjs(new Date()).add(2, 'days').isAfter(value, 'day'))) {
                                    return createError({ path, message: 'Date should be T+2' });
                                }
                                const valid = handleDateValidation(validationData?.investmentDates, dayjs(value))
                                if (valid) {
                                    return createError({
                                        message: `Only ${validationData?.investmentDates.join(', ')} are allowed`,
                                        path
                                    })
                                }
                                return true
                            }),
                            mandate: Yup.string().required('Mandate is Required'),
                            ...(isInvestMore ? {} : {
                                sipFolio: Yup.string().required('Required'),
                            }),
                        }),
                        otherwise: Yup.object().shape({
                            sipamount: Yup.number().notRequired(),
                            periods: Yup.string().notRequired(),
                            installments: Yup.number().notRequired(),
                            sipDate: Yup.date().notRequired(),
                            mandate: Yup.string().notRequired(),
                            sipFolio: Yup.string().notRequired(),
                        })
                    }),
                })
            )
        }),
        ...((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
           isRMLikeRole(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            documents: Yup.array().of(
                Yup.object().shape({
                    documentId: Yup.string(),
                    documentType: Yup.string()
                })
            )
        } : {}),
        ...((
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            bankAccountNumber: Yup.string().required("Bank Account is Required")
        } : {})
    });


    const fetchAll = async () => {
        try {
            if (!(selectedSchemes ?? []).length) {
                setIsLoading(false)

                setFormInitialData({
                    fund: [],
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        isRMLikeRole(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: [{
                            documentId: "",
                            documentType: ""
                        }]
                    } : {}),
                    ...((
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        bankAccountNumber: ""
                    } : {}),
                } as any);

                return
            }

            setIsLoading(true);
            // setUserLoading(true);

            const payload = {
                schemeIds: selectedSchemes?.map((item: any) => item?.scheme ? item?.scheme : item),
                portfolioId: selectedPortfolio?.value,
                clientCode: clientCode,
                rmId: `${investorRmId}`,
                schemeDetails: selectedSchemes?.map((obj: any) => ({
                    scheme_id: obj?.scheme ?? "",
                    isReinvestment: obj?.isReinvestment ? obj?.isReinvestment : obj?.divReinvestAllowed ?? "",
                }))
            }
            // const [investmentUserDetailsResponse, mandateListResponse, investmentDetailsResponse] = await Promise.all([
            //     dispatch(getInvestmentUserDetails({ clientCode, portfolioId: selectedPortfolio?.value })) as unknown as GetInvestmentUserDetails,
            //     (dispatch(getMandatesList({ clientCode: clientCode, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<Array<MandatesListResBody>>),
            //     (dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown,
            // ]);

            const [mandateListResponse, investmentDetailsResponse] = await Promise.all([
                (dispatch(getMandatesList({ clientCode: clientCode, status: 'Active', portfolioId: selectedPortfolio?.value })) as unknown as Promise<MandatesListResBody>),
                (dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown,
            ]);

            // setUserDetails(investmentUserDetailsResponse as GetInvestmentUserDetails);
            setActiveManListRes(mandateListResponse);
            setActiveMandateList(mandateListResponse?.mandates || []);
            setDetails(investmentDetailsResponse as GETINVESTMENTDETAILTYPE);

            if (
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
            ) {
                const getOrderEntryBanksListResponse = await (dispatch(getOrderEntryBanksList({
                    clientCode
                })) as unknown as Promise<GetOrderEntryBanksListResponseBody>);

                setBankAccountList(getOrderEntryBanksListResponse)
            }
            const firstActiveMandate = mandateListResponse?.mandates?.filter((mandate: MandateListItem) => Number(mandate?.amount) >= 25000)?.[0];
            const isActiveMandPresent = isComingFromIndFund ? false : Object.keys(firstActiveMandate ?? {}).length > 0;

            const banksListRes = await (dispatch(getMandateCreationDetails({ clientCode: clientCode, portfolioId: selectedPortfolio?.value })) as unknown as Promise<Array<MandateCreation>>);
            setBanksList(banksListRes);

            const formInitial = [...((investmentDetailsResponse as GETINVESTMENTDETAILTYPE)?.investmentDetails || [])]?.map((item, i) => {
                const sipTxns = item.frequencies?.filter((freq) => freq?.transactionType === 'SIP')
                const sipValidations = item?.validations?.filter((freq) => freq?.transactionType === 'SIP')
                const monthlyTxn = sipTxns?.find(
                    txn => txn.frequency?.toLowerCase() === 'monthly'
                );
                const selectedFrequency = monthlyTxn?.frequency || sipTxns[0]?.frequency;
                const matchingTxns = sipValidations?.filter(
                    txn => txn?.frequency?.toLowerCase() === (selectedFrequency ?? "")?.toLowerCase()
                );
                const maximumInstallments = matchingTxns?.[0]?.maximumInstallments || 0;
                const investmentDates = matchingTxns?.[0]?.investmentDates || [];
                return ({
                    ...initialData?.fund?.[0],
                    sip: {
                        // ...initialData?.fund?.[0]?.sip,
                        sipamount: isComingFromIndFund ? sipAmount : '25000',
                        // periods: item.frequencies.filter((freq) => freq.transactionType === 'SIP')[0]?.frequency || '',
                        periods: selectedFrequency || '',
                        installments: maximumInstallments || '',
                        // sipDate: isActiveMandPresent ? dayjs().add(1, 'day').format("YYYY-MM-DD") : dayjs().add(31, 'days').format("YYYY-MM-DD"),
                        sipDate: findNextValidDate(investmentDates, isActiveMandPresent ? 'active' : 'pending', true, selectedFrequency),
                        mandate: {
                            mandateId: "",
                            amount: isComingFromIndFund ? sipAmount : '100000',
                            accountNo: !isActiveMandPresent ? banksListRes?.[0]?.bankAccountNumber : firstActiveMandate?.accountNo ?? "",
                            ifscCode: '',
                            bankName: !isActiveMandPresent ? banksListRes?.[0]?.bankName : firstActiveMandate?.bankName ?? "",
                            startDate: dayjs().format("YYYY-MM-DD"),
                            endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                            curMandateStatus: "",
                        },
                        sipFolio: item?.folios?.availableFolios[0] || '',
                        firstOrder: true,
                        curMandateStatus: isActiveMandPresent ? 'active' : 'pending',
                        pending: {
                            amount: isComingFromIndFund ? sipAmount : '100000',
                            accountNo: !isActiveMandPresent ? banksListRes?.[0]?.bankAccountNumber : '',
                            ifscCode: '',
                            bankName: !isActiveMandPresent ? banksListRes?.[0]?.bankName : '',
                            startDate: dayjs().format("YYYY-MM-DD"),
                            endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                            acctType: ""
                        },
                        active: {
                            mandateId: isActiveMandPresent ? firstActiveMandate?.mandateId : '',
                        },
                        freshMandatePayload: !isActiveMandPresent ? {
                            // mandateId: "",
                            // amount: isComingFromIndFund ? sipAmount : '100000',
                            // accountNo: !isActiveMandPresent ? banksListRes?.[0]?.bankAccountNumber : '',
                            // ifscCode: !isActiveMandPresent ? banksListRes?.[0]?.ifscCode : '',
                            // bankName: !isActiveMandPresent ? banksListRes?.[0]?.bankName : '',
                            // startDate: dayjs().format("YYYY-MM-DD"),
                            // endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                            // curMandateStatus: "",
                            amount: isComingFromIndFund ? sipAmount : '100000',
                            actype: !isActiveMandPresent ? banksListRes?.[0]?.bankAccountType : '',
                            mandateType: "N",
                            clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                            ifscCode: !isActiveMandPresent ? banksListRes?.[0]?.ifscCode : '',
                            accountNo: !isActiveMandPresent ? banksListRes?.[0]?.bankAccountNumber : '',
                            bankName: !isActiveMandPresent ? banksListRes?.[0]?.bankName : '',
                            portfolioId: selectedPortfolio?.value,
                            startDate: dayjs().format("MM/DD/YYYY"),
                            endDate: dayjs().add(40, 'year').subtract(1, 'month').format("MM/DD/YYYY"),
                        } : {},
                        sipEndDate: item?.sip?.sipEndDate ?? ""
                        // curMandateStatus: '',
                        // mandateCreationDate: '',
                    },
                    lumpsum: {
                        lumpAmount: '50000',
                        // ...initialData?.fund?.[0]?.lumpsum,
                        lumpsumFolio: item?.folios?.availableFolios[0] || '',
                    },
                    lumpsumSip: {
                        lumpSumAmount: '',
                        sipAmount: '',
                        periods: item.frequencies.filter((freq) => freq.transactionType === 'SIP')[0]?.frequency || '',
                        installments: '',
                        sipDate: '',
                        mandate: mandateListResponse?.mandates?.[0]?.mandateId || '',
                        sipFolio: item?.folios?.availableFolios[0] || '',
                    },
                    activeTab: isComingFromIndFund ? 'SIP' : 'Lumpsum',
                    schemeId: item.schemeId,
                    mandate: mandateListResponse?.mandates,
                    folio: folio[i],
                    sipEndDate: '',
                    ...(isInvestMore ? {
                        uniqueId: selectedSchemes?.[i]?.uniqueId ?? ""
                    } : {}),
                    ...item,
                })
            })

            const modifiedInitialData = formInitial.map((item, i) => {
                const currentStateFund = stateFund[i];
                const bankDetailsForActiveMand = mandateListResponse?.mandates?.find((mandate: any) => mandate.mandateId === currentStateFund?.sip?.active?.mandateId);
                return {
                    ...item,
                    ...(currentStateFund && {
                        activeTab: currentStateFund.activeTab,
                        // activeTab: currentStateFund.isEditCart ? currentStateFund.activeTab : isComingFromIndFund ? 'SIP' : 'Lumpsum',
                    }),
                    ...(currentStateFund && currentStateFund.activeTab === "Lumpsum" && {
                        lumpsum: {
                            ...item.lumpsum,
                            lumpAmount: currentStateFund.lumpsum.lumpAmount,
                            lumpsumFolio: currentStateFund.lumpsum.lumpsumFolio,
                        }
                    }),
                    ...(currentStateFund && currentStateFund.activeTab === "SIP" && {
                        sip: {
                            ...item.sip,
                            sipamount: currentStateFund.sip.sipamount,
                            periods: currentStateFund.sip.periods,
                            installments: currentStateFund.sip.installments,
                            sipDate: currentStateFund.sip.sipDate,
                            sipEndDate: currentStateFund.sip.sipEndDate,
                            sipFolio: currentStateFund.sip.sipFolio,
                            mandate: currentStateFund.sip.curMandateStatus === "pending" ?
                                currentStateFund.sip.mandate : {
                                    ...currentStateFund.sip.mandate,
                                    ...bankDetailsForActiveMand
                                },
                            freshMandatePayload: currentStateFund.sip.curMandateStatus === "pending" ? currentStateFund.sip.mandate : {},
                            firstOrder: currentStateFund.sip.firstOrder,
                            curMandateStatus: currentStateFund.sip.curMandateStatus,
                            pending: currentStateFund.sip.pending,
                            active: currentStateFund.sip.active
                        }
                    })
                }
            })

            setFormInitialData({
                fund: isComingFromIndFund ? formInitial : (COMMON_EDIT ? modifiedInitialData : formInitial),
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    isRMLikeRole(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: [{
                        documentId: "",
                        documentType: ""
                    }]
                } : {}),
                ...((
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    bankAccountNumber: ""
                } : {}),
            } as any);
        } catch (e) {
            console.log('error', e);
            throw e
        } finally {
            setIsLoading(false);
            // setUserLoading(false);
        }
    };

    const getUserData = async () => {
        try {
            setUserLoading(true);
            if (clientCode) {

                const investmentUserDetailsResponse = (await dispatch(getInvestmentUserDetails({
                    clientCode,
                    portfolioId: selectedPortfolio?.value
                }))) as unknown | GetInvestmentUserDetails;

                setUserDetails(investmentUserDetailsResponse as GetInvestmentUserDetails);
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setUserLoading(false)
        }
    }

    useEffect(() => {
        const getDataFromApi = async () => {
            await Promise.allSettled([fetchAll(), getUserData()])
        }
        if (clientCode) getDataFromApi()
    }, [clientCode]);

    //router for bread crum
    const initialRouter = pathname?.split('/').filter((item) => item !== '')

    const rmRouterPath = [
        {
            name: 'Dashboard',
            path: '/dashboard',
            warning: selectedSchemes?.length > 0,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: initialRouter[1] + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            },
            warning: selectedSchemes?.length > 0,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Detailed Portfolio Holdings',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode
            },
            warning: selectedSchemes?.length > 0 && !(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'),
            search: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "?tab=Holdings" : `tab=Overview&portfolio=${selectedPortfolio?.value ?? ""}`,
            handleClick: () => {
                if (!(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more')) dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        ...(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? [
        ] : [
            {
                name: 'Explore Mutual Funds',
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
                state: {
                    clientCode
                }
            },
        ]),
        {
            name: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Invest More" : 'Investment Details',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`,
        },
    ]

    const investorRouterPath = [
        ...(familyMemberId
            ?
            [{
                name: 'View Family',
                path: `/investor-family/family-profile/${familyMemberId}`,
            },
            {
                name: `${initialRouter[1]}`,
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
            }]
            :
            [
                {
                    name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
                    path: '/investor-dashboard',
                    warning: selectedSchemes?.length > 0,
                    handleClick: () => {
                        dispatch(setSelectedAllHoldingsInfo([]))
                    }
                },
            ]
        ),
        {
            name: 'Detailed Portfolio Holdings',
            path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}` : `/${initialRouter[0]}/${initialRouter[1]}`),
            state: {
                clientCode
            },
            warning: selectedSchemes?.length > 0 && !(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'),
            search: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "?tab=Holdings" : `tab=Overview&portfolio=${selectedPortfolio?.value ?? ""}`,
            handleClick: () => {
                if (!(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more')) dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        ...(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? [
        ] : [
            {
                name: 'Explore Mutual Funds',
                path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}` : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`),
                state: {
                    clientCode
                }
            },

        ]),
        ...(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? [
        ] : [
            ...(initialRouter.includes('selected-category-funds') ? [{
                name: 'Selected Category Funds',
                path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}` : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`),
                state: {
                    clientCode,
                    selectedCategory
                }
            }] : [])
        ]
        ),
        {
            name: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Invest More" : 'Investment Details',
            path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}/${initialRouter[5]}` : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`),
            state: {
                clientCode
            }
        },
    ]


    const handleConformOrder = async () => {
        setApiLoading(true)

        const selectedBankDetailsObj = (bankAccountList?.bankDetails ?? [])?.find(obj => `${obj?.bankAccNo ?? ""}` === `${formRef.current?.values?.bankAccountNumber ?? ""}`)

        try {
            const payload = [...formRef.current?.values?.fund].map((item, i) => {
                return {
                    "clientCode": clientInterfaceCode ? clientInterfaceCode : clientCode,
                    "fromScheme": item.schemeId,
                    "schemeName": item.fundName,
                    "mobile": userDetails?.mobile,
                    "email": userDetails?.email,
                    amcId: item.fundAmcId,
                    folio: item?.activeTab?.toLowerCase() === "lumpsum" ? item?.lumpsum?.lumpsumFolio : item?.sip?.sipFolio,
                    ...((item?.activeTab?.toLowerCase() === 'lumpsum') ? {
                        amount: item?.lumpsum?.lumpAmount,
                        trType: "FRESH",
                        // trType: "LUMPSUM",
                        ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                            folio: item?.folio?.folioId,
                            trType: "ADDITIONAL",
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankName: selectedBankDetailsObj?.bankname ?? "",
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                            bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                        } : {})
                    } : {
                        trType: "XSIP",
                        transactionStartDate: dayjs(item?.sip?.sipDate).format("DD/MM/YYYY"),
                        // mandateId: item?.sip?.mandate,
                        mandateId: item?.sip?.curMandateStatus === 'active' ? item?.sip?.active?.mandateId : null,
                        noOfInstallments: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? '0' : item?.sip?.installments,
                        transactionEndDate: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? dayjs(item?.sip?.sipEndDate).format("DD/MM/YYYY") : "",
                        frequency: item?.sip?.periods,
                        amount: item?.sip?.sipamount,
                        mandate_payload: item?.sip?.curMandateStatus === 'active' ? null : item?.sip?.freshMandatePayload ?? "",
                        // isFirstorderToday: "Y",
                        firstOrderFlag: item?.sip?.firstOrder ? "Y" : "N",
                        ...(pathname?.split('/')[pathname?.split('/')?.length - 1] !== 'invest-more' ? {} : {
                            folio: item?.folio?.folioId,
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankName: selectedBankDetailsObj?.bankname ?? "",
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                            bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                        } : {})
                    }),
                    portfolioId: selectedPortfolio?.value,
                    portfolioName: selectedPortfolio?.label,
                    rmId: `${investorRmId}`,
                    "cartId": null,
                    "isRecommended": isRMLikeRole(role) ? true : false,
                    "isDiy": role === USER_ROLES.INVESTOR ? true : false,

                }
            })


            const res = await dispatch(submitInvestmentDetails({
                // ...(ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD ? {
                accountType: selectedPortfolioObj?.portfolioAccountType,
                // } : {}),
                orderDetails: payload,
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                   isRMLikeRole(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: formRef?.current?.values?.documents?.filter((obj: {
                        documentId: string;
                        documentType: string;
                    }) => obj.documentId !== "" && obj.documentType !== "")
                } : {})
            })) as unknown as {
                isSuccess: boolean,
                message: string,
                ordersValidation: Array<any>
                isPaymentFlow?: boolean
                token?: string
                cartId?: string
                otp_response?: any
            };

            if (res.isSuccess) {
                if (role === USER_ROLES.INVESTOR) {
                    if (res?.isPaymentFlow) {
                        history.push(`/cart/verify-otp`, {
                            token: res?.token ?? "",
                            cartId: res?.cartId ?? "",
                            id: res?.otp_response?.id ?? "",
                            otpMessage: res?.otp_response?.message ?? "",
                        })
                    }
                }
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res?.ordersValidation.length > 0) {
                    // if (res.message) {
                    //     setFiveSchemesDialogVisible(true)
                    // } else {
                    setValidationErrorsArray(
                        res?.ordersValidation
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data?.schemeName,
                                errorMessage: data?.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }
        } catch (error) {
            console.log('error', error);
        }

        setConfirmRecomment(false);
        setRiskProfilePopup(false);
        setApiLoading(false)

    };

    const handleConfromRecomment = async () => {
        setApiLoading(true)

        const selectedBankDetailsObj = (bankAccountList?.bankDetails ?? [])?.find(obj => `${obj?.bankAccNo ?? ""}` === `${formRef.current?.values?.bankAccountNumber ?? ""}`)


        const payload = [...formRef.current?.values?.fund].map((item, i) => {
            return {
                // "trType": "FRESH",
                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                amcId: item.fundAmcId,
                schemeId: item.schemeId,
                schemeName: item.fundName,
                categoryName: item.fundType,
                subCategoryName: item.fundCap,
                riskType: item.riskType,
                aumAmount: item.detailsList[0].value,
                navValue: item.detailsList[1].value,
                y3Returns: item.detailsList[2].value,
                exitLoad: item.detailsList[3].value,
                investedValue: 0,
                marketValue: 0,
                recommendedDate: dayjs().format("DD/MM/YYYY"),
                imgUrl: item.fundImage,
                folioNo: item?.activeTab?.toLowerCase() === "lumpsum" ? item?.lumpsum?.lumpsumFolio : item?.sip?.sipFolio,
                ...(item?.activeTab?.toLowerCase() === "lumpsum" ? {
                    buySellType: "LUMPSUM",
                    recommendedAmount: `${item.lumpsum?.lumpAmount}`,
                    ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                        folioNo: item?.folio?.folioId,
                        investedValue: folio?.[i].investedValue,
                        marketValue: folio?.[i].marketValue,
                    }),
                    ...((
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        bankName: selectedBankDetailsObj?.bankname ?? "",
                        bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                        bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                    } : {})
                } : {
                    buySellType: "XSIP",
                    // mandateId: item?.sip?.mandate,
                    mandateId: item?.sip?.curMandateStatus === 'active' ? item?.sip?.active?.mandateId : null,
                    noOfInstallments: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? '0' : `${item?.sip?.installments ?? ""}`,
                    systematicDate: dayjs(item?.sip?.sipDate).format("DD/MM/YYYY"),
                    frequency: item?.sip?.periods,
                    recommendedAmount: `${item?.sip?.sipamount}`,
                    mandate_payload: item?.sip?.curMandateStatus === 'active' ? null : item?.sip?.freshMandatePayload ?? "",
                    firstOrderFlag: item?.sip?.firstOrder ? "Y" : "N",
                    endDate: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? dayjs(item?.sip?.sipEndDate).format("DD/MM/YYYY") : "",
                    ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                        folioNo: item?.folio?.folioId,
                        investedValue: folio?.[i].investedValue,
                        marketValue: folio?.[i].marketValue,
                    }),
                    ...((
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        bankName: selectedBankDetailsObj?.bankname ?? "",
                        bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                        bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                    } : {})
                }),
                portfolioId: selectedPortfolio?.value,
                rmId: `${investorRmId}`
            }
        })



        const res = (await dispatch(submitRecomment(payload))) as unknown as {
            isSuccess: boolean,
            message: string,
            response: Array<any>
        };

        if (res.isSuccess) {
            setRecommendPlaceOrderResponse(res)

            setConfirmRecomment(false)
            dispatch(setSelectedHoldingsIds([]))
            dispatch(setCheckedHoldingSchemes([]))
            dispatch(setSelectedHoldingsInfo([]))
            dispatch(setSelectedAllHoldingsInfo([]))

            setSuccessModal(true);
        } else if (!res.isSuccess) {
            setConfirmRecomment(false)
            if (res?.response.length > 0) {
                // if (res.message) {
                //     setFiveSchemesDialogVisible(true)
                // } else {
                setValidationErrorsArray(
                    res.response
                        .filter(data => !data.isSuccess)
                        .map(data => ({
                            schemeName: data.schemeName,
                            errorMessage: data.message
                        }))
                )
                setValidationDialogVisible(true)
            }
        }

        setApiLoading(false);
    }

    const handleRiskProfilePopup = (btnText: string) => {
        if (btnText === 'cancel' && isRMLikeRole(role)) {
            if (pathname.includes('invest-more')) {
                history.goBack();
            }
            history.push(`/investor-profile/${selectedPortfolio?.label}/mutual-fund/explore`, state);
        }
        else if (btnText === 'continue') {
            setConfirmRecomment(true);
        }
        setRiskProfilePopup(false);
    }

    const handleSuccess = () => {
        history.push('/cart', { clientCode })
    }

    const handleSuccessPopup = () => {
        dispatch(setAppliedFundsFilters([]));
        dispatch(setSelectedSchemesObj({}));

        if (role === USER_ROLES.INVESTOR) {
            history.push('/investor-dashboard')
        } else {
            history.push('/dashboard')
        }
        // if (role === USER_ROLES.INVESTOR) {
        //     history.push(`/${initialRouter[0]}/${initialRouter[1]}`, { clientCode })
        // } else {
        //     history.push(`/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`, { clientCode })
        // }

    }

    const handleCloseFiveSchemesDialog = () => {
        setFiveSchemesDialogVisible(false)
    }

    const handleValidationDialogClose = () => {
        setValidationDialogVisible(false)
    }


    const hasDuplicateSchemes = (arr: any) => {
        const codeSet = new Set();

        for (const item of arr) {
            const key = `${item?.isinCode ?? ""}-${item?.folio?.folioId ?? ""}`;
            if (codeSet.has(key)) {
                return true;
            }
            codeSet.add(key);
        }

        return false;
    }

    const handleSameSchemeDialogClose = () => {
        setSameSchemesDialogOpen(false)
    }

    const handleSameSchemeDialogConfirm = async () => {
        handleSameSchemeDialogClose()

        if (!formRef.current) {
            return
        }

        if (orderType === 'investor') {

            const selectedBankDetailsObj = (bankAccountList?.bankDetails ?? [])?.find(obj => `${obj?.bankAccNo ?? ""}` === `${formRef.current?.values?.bankAccountNumber ?? ""}`)

            try {
                setApiLoading(true);
                const payload = [...formRef.current?.values?.fund].map((item, i) => {
                    return {
                        categoryName: item.fundType,
                        isDividendReinvestment: item?.divReinvestAllowed ?? "",
                        mPowerScheme: item?.mPowerScheme ?? "",
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        navValue: item.detailsList[1].value,
                        y3Returns: item.detailsList[2].value,
                        exitLoad: item.detailsList[3].value,
                        aumAmount: item.detailsList[0].value,
                        riskType: item.riskType,
                        schemeId: item.schemeId,
                        schemeName: item.fundName,
                        subCategoryName: item.fundCap,
                        isRecommended: false,
                        navDate: item.detailsList[1].title.slice(5),
                        folioNo: item?.activeTab?.toLowerCase() === "lumpsum" ? item?.lumpsum?.lumpsumFolio : item?.sip?.sipFolio,
                        trType: (item?.activeTab?.toLowerCase() === "lumpsum") ? (
                            isInvestMore ?
                                "ADDITIONAL" :
                                `${item?.lumpsum?.lumpsumFolio ?? ""}`.toLowerCase() === "new folio" ? "FRESH" : "ADDITIONAL"
                        ) : 'SIP',
                        investedValue: "0",
                        marketValue: "0",
                        amcId: item.fundAmcId,
                        ...((item?.activeTab?.toLowerCase() === 'lumpsum') ? {
                            amount: item?.lumpsum?.lumpAmount,
                            ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                                folioNo: item?.folio?.folioId,
                                // folioNo: folio?.filter(folioItem => folioItem.schemeId === details?.investmentDetails[i]?.schemeId)?.[0]?.id,
                                investedValue: `${folio?.[i]?.investedValue}`,
                                marketValue: `${folio?.[i]?.marketValue}`,
                            }),
                            ...((
                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                            ) ? {
                                bankName: selectedBankDetailsObj?.bankname ?? "",
                                bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                                bankIfsc: selectedBankDetailsObj?.ifscCode ?? "",
                            } : {})
                        } : {
                            amount: item?.sip?.sipamount,
                            // mandateId: item?.sip?.mandate,
                            mandateId: item?.sip?.curMandateStatus === 'active' ? item?.sip?.active?.mandateId : null,
                            frequency: item?.sip?.periods,
                            noOfInstallment: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? '0' : item?.sip?.installments,
                            endDate: (`${item?.sip?.periods ?? ""}`.toUpperCase() === 'DAILY') ? dayjs(item?.sip?.sipEndDate).format("DD/MM/YYYY") : "",
                            sipDate: dayjs(item?.sip?.sipDate).format("DD/MM/YYYY"),
                            mandate_payload: item?.sip?.curMandateStatus === 'active' ? null : item?.sip?.freshMandatePayload ?? "",
                            firstOrderFlag: item?.sip?.firstOrder ? "Y" : "N",
                            ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                                folioNo: item?.folio?.folioId,
                                // folioNo: folio?.filter(folioItem => folioItem?.schemeId === details?.investmentDetails[i]?.schemeId)?.[0]?.id,
                                investedValue: `${folio?.[i]?.investedValue}`,
                                marketValue: `${folio?.[i]?.marketValue}`,
                            }),
                            ...((
                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                            ) ? {
                                bankName: selectedBankDetailsObj?.bankname ?? "",
                                bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                                bankIfsc: selectedBankDetailsObj?.ifscCode ?? "",
                            } : {})
                        }),
                        portfolioId: selectedPortfolio?.value,
                        // folioNo: item?.sip?.sipFolio || item?.lumpsum?.lumpsumFolio,
                        rmId: `${investorRmId}`,
                        transMode: 'A',
                    }
                })

                const res = ((await dispatch(addToCart(payload as any))) as unknown) as AddToCartResponseBody;
                if (res?.isSuccess) {
                    setConfirmRecomment(false)
                    const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        portfolioId: selectedPortfolio?.value
                    })) as unknown as Promise<GetCartItemsCountResponseBody>)

                    if (isSuccess) {
                        dispatch(setCartItemsCount(cartItemsCount));
                        dispatch(setSelectedHoldingsInfo([]))
                        dispatch(setSelectedAllHoldingsInfo([]))
                    }

                    setCartPopup(true)
                } else if (!res?.isSuccess) {
                    setConfirmRecomment(false)
                    if (res?.message) {
                        setFiveSchemesDialogVisible(true)
                    } else {
                        setValidationErrorsArray(
                            res?.response
                                .filter(data => !data.isSuccess)
                                .map(data => ({
                                    schemeName: data.schemeName,
                                    errorMessage: data.message
                                }))
                        )
                        setValidationDialogVisible(true)
                    }
                }
                setApiLoading(false);
            } catch (err) {
                console.log(err)
            } finally {
                setApiLoading(false);
            }
        } else {
            try {
                setRiskPflChkLoading(true);
                const riskProfileCheckRes = (await dispatch(getRiskProfileCheck({
                    clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                    // schemeCode: details.investmentDetails?.map((item: any) => {
                    //     return item?.schemeId
                    // })
                    schemeCode: (formRef.current?.values?.fund ?? [])?.map((item: any) => {
                        return item?.schemeId
                    })
                }))) as unknown as {
                    isSuccess: boolean,
                    displayText: string
                }
                if (orderType === 'order') {

                    if (!riskProfileCheckRes?.isSuccess) {
                        setRiskProfilePopup(true)
                        setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                    } else {
                        // setConfirmRecomment(true)
                        handleConformOrder()
                    }
                } else {
                    if (!riskProfileCheckRes?.isSuccess) {
                        setRiskProfilePopup(true)
                        setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                    } else {
                        setConfirmRecomment(true)
                    }
                }
            } catch (e) {
                console.log('error', e)
            } finally {
                setRiskPflChkLoading(false);
            }
        }
    }

    const newHandleSubmit = async (value: FormikValues) => {
        if ((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            isRMLikeRole(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        )) {
            if (value?.documents?.length === 1 && (value?.documents[0]?.documentId === '' || value?.documents[0]?.documentType === '')) {
                setDocumentUploadErrorDialogVisible(true)
                return
            }
        }

        if (isInvestMore) {

            // Checking if multiple orders with the same scheme/folio combination are there ot not

            const hasDuplicates = hasDuplicateSchemes(value?.fund ?? [])

            if (hasDuplicates) {
                setSameSchemesDialogOpen(true)
                return
            } else {
                handleSameSchemeDialogConfirm()
            }
        } else {
            handleSameSchemeDialogConfirm()
        }
    }

    const handleAddMore = () => {
        if (pathname.split('/').slice(-2)[0] === 'explore') {
            history.push(pathname.split('/').slice(0, -1).join('/'), { clientCode })
        } else {
            history.push(pathname.split('/').slice(0, -2).join('/'), { clientCode })
        }
    }

    const handleDelete = (id: number | string, checkId?: string, selectedUniqueId?: string) => {

        setDetails((pre: GETINVESTMENTDETAILTYPE) => {

            const result = pre?.investmentDetails?.filter((item) => item?.schemeId !== checkId);
            const result1 = pre?.investmentDetails?.filter((item) => item?.schemeId !== id);

            if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {

                // const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => (item?.scheme || item) !== id);
                const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => item.uniqueId !== selectedUniqueId);

                history.replace({
                    state: ({
                        selectedSchemes: modifiedSelectedSchemes,
                        clientCode,
                        schemeDetails: (modifiedSelectedSchemes ?? [])
                            .map(item => ({
                                scheme_id: item?.schemeId ?? "-",
                                isReinvestment: item?.isReinvest ?? "-"
                            })),
                        // folio: modifiedSelectedSchemes,
                        folio: (modifiedSelectedSchemes ?? [])
                            .map(item => ({
                                folioId: item.folioId,
                                schemeId: item.scheme,
                                id: item.id,
                                marketValue: item.marketValue,
                                investedValue: item.investedValue,
                            })),
                    })
                })
                // const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ id }) => id !== checkId)

                // dispatch(setSelectedAllHoldingsInfo([...modifiedSelectedAllHoldingsInfo]))

                // const modifiedCheckedIds = [...holdingsData].filter((obj) => checkedHoldingInvestments.includes(obj.id)).map(obj => obj.id)

                // dispatch(setSelectedHoldingsIds(modifiedSelectedSchemes))

            } else {
                history.replace({ state: { selectedSchemes: selectedSchemes?.filter((item: any) => (item?.scheme ? item?.scheme : item) !== id), clientCode } })

                const modifiedSelectedSchemesObj = Object.fromEntries(Object.entries(selectedSchemesObj).filter(([key, _]) => key !== `${id}`))

                dispatch(setSelectedSchemesObj(modifiedSelectedSchemesObj))

            }

            return { ...pre, investmentDetails: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? result : result1 };
        })
    }

    const handleAddMoreProceed = () => {
        if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {
            history.replace({ state: ({ selectedSchemes: radioValue.map((obj: any) => (obj?.scheme || obj)), clientCode }) })

            dispatch(setSelectedHoldingsIds(radioValue.map((obj: any) => (obj?.scheme || obj))))

            addFunds(radioValue?.map((obj: any) => (obj?.scheme || obj)))
        } else {
            history.replace({ state: ({ selectedSchemes: radioValue, clientCode }) })

            const selectedSchemesObj = radioValue.reduce((acc: any, obj: any) => {
                acc[obj.scheme] = {
                    ...obj,
                    scheme: `${obj.scheme}`,
                    checked: obj.checked ? obj.checked : true,
                };
                return acc;
            }, {});
            dispatch(setSelectedSchemesObj(selectedSchemesObj))

            addFunds(selectedSchemesObj)
        }
        setOpen(false);

    }

    const addFunds = async (schemes: any, addedFolio?: any) => {
        try {
            const mandateStatus = activeMandateList.length > 0 ? activeMandateList?.[0]?.status?.toLowerCase() === 'under process' ? 'pending' : 'active' : '';

            if (isInvestMore) {

                // schemes currently in formik
                const currentSchemesArr = (formRef.current?.values?.fund ?? []).map((obj: any) => ({ uniqueId: obj?.uniqueId ?? "" }))

                // latest added schemes excluding the schemes in formik
                const latestAddedSchemes = schemes?.filter((obj: any) => !currentSchemesArr.find((currObj: any) => currObj.uniqueId === obj.uniqueId))

                if (!(latestAddedSchemes ?? []).length) {
                    return
                }

                setIsLoading(true);

                const payload = {
                    // passing only those schemeIds which have been added via Add more funds, NOT passing those schemes already in Formik
                    // schemeIds: Object.values(schemes)?.map((item: any) => item?.scheme ? item?.scheme : item),
                    schemeIds: (latestAddedSchemes ?? [])?.map((item: any) => item?.scheme ?? ""),
                    portfolioId: selectedPortfolio?.value,
                    clientCode: clientCode,
                    rmId: `${investorRmId}`,
                    // schemeDetails: Object.values(schemes)?.map((obj: any) => ({
                    //     scheme_id: obj?.scheme ?? "",
                    //     isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                    // }))
                    schemeDetails: (latestAddedSchemes ?? [])?.map((obj: any) => ({
                        scheme_id: obj?.scheme ?? "",
                        isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                    }))
                }

                const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown
                setDetails(res as GETINVESTMENTDETAILTYPE);

                // extracting ISIN codes from the response
                const responseIsinCodes = ((res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []).map((item: any) => item.isinCode) as Array<string>

                // Filtering out those schemes for which we did not get the api response based on the isin code
                const modifiedLatestAddedSchemes = latestAddedSchemes.filter((item: any) => responseIsinCodes.includes(item.isinCode));


                const formInitial = [...(res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []].map((item, i) => {

                    const addedFolio = {
                        folioId: modifiedLatestAddedSchemes[i].folioId,
                        schemeId: modifiedLatestAddedSchemes[i].scheme,
                        id: modifiedLatestAddedSchemes[i].id,
                        marketValue: modifiedLatestAddedSchemes[i].marketValue,
                        investedValue: modifiedLatestAddedSchemes[i].investedValue,
                    }

                    const sipTxns = item.frequencies?.filter((freq) => freq?.transactionType === 'SIP')
                    const sipValidations = item?.validations?.filter((freq) => freq?.transactionType === 'SIP')
                    const monthlyTxn = sipTxns?.find(
                        txn => txn.frequency?.toLowerCase() === 'monthly'
                    );
                    const selectedFrequency = monthlyTxn?.frequency || sipTxns[0]?.frequency;
                    const matchingTxns = sipValidations?.filter(
                        txn => txn?.frequency?.toLowerCase() === (selectedFrequency ?? "")?.toLowerCase()
                    );
                    const maximumInstallments = matchingTxns?.[0]?.maximumInstallments || 0;

                    const firstActiveMandate = activeMandateList?.filter((mandate: MandateListItem) => Number(mandate?.amount) >= 25000)?.[0];
                    const isActiveMandPresent = Object.keys(firstActiveMandate ?? {}).length > 0;
                    const investmentDates = matchingTxns?.[0]?.investmentDates || [];

                    return {
                        ...item,
                        sip: {
                            sipamount: '25000',
                            periods: selectedFrequency || '',
                            installments: maximumInstallments || '',
                            // sipDate: isActiveMandPresent ? dayjs().add(1, 'day').format("YYYY-MM-DD") : dayjs().add(31, 'days').format("YYYY-MM-DD"),
                            sipDate: findNextValidDate(investmentDates, isActiveMandPresent ? 'active' : 'pending', true, selectedFrequency),
                            mandate: {
                                mandateId: "",
                                amount: '100000',
                                accountNo: !isActiveMandPresent ? banksList?.[0]?.bankAccountNumber : firstActiveMandate?.accountNo ?? "",
                                ifscCode: '',
                                bankName: !isActiveMandPresent ? banksList?.[0]?.bankName : firstActiveMandate?.bankName ?? "",
                                startDate: dayjs().format("YYYY-MM-DD"),
                                endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                                curMandateStatus: "",
                            },
                            sipFolio: item?.folios?.availableFolios[0] || '',
                            firstOrder: true,
                            curMandateStatus: isActiveMandPresent ? 'active' : 'pending',
                            pending: {
                                amount: '100000',
                                accountNo: !isActiveMandPresent ? banksList?.[0]?.bankAccountNumber : '',
                                ifscCode: '',
                                bankName: !isActiveMandPresent ? banksList?.[0]?.bankName : '',
                                startDate: dayjs().format("YYYY-MM-DD"),
                                endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                                acctType: ""
                            },
                            active: {
                                mandateId: isActiveMandPresent ? firstActiveMandate?.mandateId : '',
                            },
                            freshMandatePayload: !isActiveMandPresent ? {
                                amount: isComingFromIndFund ? sipAmount : '100000',
                                actype: !isActiveMandPresent ? banksList?.[0]?.bankAccountType : '',
                                mandateType: "N",
                                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                                ifscCode: !isActiveMandPresent ? banksList?.[0]?.ifscCode : '',
                                accountNo: !isActiveMandPresent ? banksList?.[0]?.bankAccountNumber : '',
                                bankName: !isActiveMandPresent ? banksList?.[0]?.bankName : '',
                                portfolioId: selectedPortfolio?.value,
                                startDate: dayjs().format("MM/DD/YYYY"),
                                endDate: dayjs().add(40, 'year').subtract(1, 'month').format("MM/DD/YYYY"),
                            } : {},
                            sipEndDate: '',
                            // curMandateStatus: '',
                            // mandateCreationDate: '',
                        },
                        lumpsum: {
                            lumpAmount: '50000',
                            lumpsumFolio: item?.folios?.availableFolios[0] || '',
                        },
                        lumpsumSip: {
                            lumpSumAmount: '',
                            sipAmount: '',
                            periods: item?.frequencies?.filter((freq) => freq.transactionType === 'SIP')[0]?.frequency || '',
                            installments: '',
                            sipDate: '',
                            mandate: activeMandateList[0]?.mandateId || '',
                            sipFolio: item?.folios?.availableFolios[0] || '',
                        },
                        activeTab: 'Lumpsum',
                        schemeId: item?.schemeId,
                        mandate: activeMandateList,
                        // folio: addedFolio?.[i],
                        folio: addedFolio,
                        uniqueId: modifiedLatestAddedSchemes?.[i]?.uniqueId ?? ""
                    }
                })

                const currentForm = [...formRef.current?.values.fund]
                // const newFrom = [...formInitial]

                // const getId = (item: any) => item?.map((obj: any) => obj.folio.id)

                // const currentSchemeId = getId([...currentForm])
                // const newSchemeId = getId([...newFrom])

                // const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.folio.id))
                // const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.folio.id))

                const updatedFundsArray = [...currentForm, ...formInitial]

                history.replace({
                    state: ({
                        selectedSchemes: [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]
                            .map((item: any) => ({
                                ...item,
                                folioId: item.folioNo,
                                scheme: item.schemeId,
                                id: item.id,
                                marketValue: item.marketValue,
                                investedValue: item.investedValue,
                                isReinvestment: item?.isReinvest
                            })),
                        clientCode,
                        schemeDetails: [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]
                            .map((item: any) => ({
                                scheme_id: item?.schemeId ?? "-",
                                isReinvestment: item?.isReinvest ?? "-"
                            })),
                        folio: [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]
                            .map((item: any) => ({
                                folioId: item.folioId,
                                schemeId: item.scheme,
                                id: item.id,
                                marketValue: item.marketValue,
                                investedValue: item.investedValue,
                            }))
                    })
                })

                dispatch(setSelectedHoldingsInfo(
                    [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])].map(obj => ({
                        checkedId: obj?.id,
                        schemeId: obj?.scheme,
                        folioNo: obj?.folioNo ?? "",
                        uniqueId: obj?.uniqueId
                    }))))

                dispatch(setSelectedAllHoldingsInfo([...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]))

                formRef.current?.resetForm({
                    values: {
                        // fund: [...filteredCurrentForm, ...filteredNewData],
                        fund: updatedFundsArray,
                        ...((
                            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                            isRMLikeRole(role) &&
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            documents: formRef.current?.values?.documents ?? []
                        } : {}),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
                        } : {})
                    }
                })
            } else {
                if (!Object.keys(schemes ?? {}).length) {

                    formRef.current?.resetForm({
                        values: {
                            fund: [],
                            ...((
                                ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                isRMLikeRole(role) &&
                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                            ) ? {
                                documents: formRef.current?.values?.documents ?? []
                            } : {}),
                            ...((
                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                            ) ? {
                                bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
                            } : {})
                        }
                    })

                    return
                }

                setIsLoading(true);
                const payload = {
                    schemeIds: Object.values(schemes)?.map((item: any) => item?.scheme ? item?.scheme : item),
                    portfolioId: selectedPortfolio?.value,
                    clientCode: clientCode,
                    rmId: `${investorRmId}`,
                    schemeDetails: Object.values(schemes)?.map((obj: any) => ({
                        scheme_id: obj?.scheme ?? "",
                        isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                    }))
                }

                const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown
                setDetails(res as GETINVESTMENTDETAILTYPE);
                const formInitial = [...(res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []].map((item, i) => {
                    const sipTxns = item.frequencies?.filter((freq) => freq?.transactionType === 'SIP')
                    const sipValidations = item?.validations?.filter((freq) => freq?.transactionType === 'SIP')
                    const monthlyTxn = sipTxns?.find(
                        txn => txn.frequency?.toLowerCase() === 'monthly'
                    );
                    const selectedFrequency = monthlyTxn?.frequency || sipTxns[0]?.frequency;
                    const matchingTxns = sipValidations?.filter(
                        txn => txn?.frequency?.toLowerCase() === (selectedFrequency ?? "")?.toLowerCase()
                    );
                    const maximumInstallments = matchingTxns?.[0]?.maximumInstallments || 0;

                    const firstActiveMandate = activeMandateList?.filter((mandate: MandateListItem) => Number(mandate?.amount) >= 25000)?.[0];
                    const isActiveMandPresent = isComingFromIndFund ? false : Object.keys(firstActiveMandate ?? {}).length > 0;
                    const investmentDates = matchingTxns?.[0]?.investmentDates || [];
                    return {
                        ...item,
                        sip: {
                            sipamount: '25000',
                            // periods: item?.frequencies?.filter((freq) => freq.transactionType === 'SIP')[0]?.frequency || '',
                            periods: selectedFrequency || '',
                            installments: maximumInstallments || '',
                            // sipDate: isActiveMandPresent ? dayjs().add(1, 'day').format("YYYY-MM-DD") : dayjs().add(31, 'days').format("YYYY-MM-DD"),
                            sipDate: findNextValidDate(investmentDates, isActiveMandPresent ? "active" : "pending", true, selectedFrequency),
                            mandate: {
                                mandateId: "",
                                amount: '100000',
                                accountNo: !isActiveMandPresent ? banksList?.[0]?.bankAccountNumber : firstActiveMandate?.accountNo ?? "",
                                ifscCode: '',
                                bankName: !isActiveMandPresent ? banksList?.[0]?.bankName : firstActiveMandate?.bankName ?? "",
                                startDate: dayjs().format("YYYY-MM-DD"),
                                endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                                curMandateStatus: "",
                            },
                            sipFolio: item?.folios?.availableFolios[0] || '',
                            firstOrder: true,
                            curMandateStatus: isActiveMandPresent ? 'active' : 'pending',
                            pending: {
                                amount: '100000',
                                accountNo: !isActiveMandPresent ? banksList?.[0]?.bankAccountNumber : '',
                                ifscCode: '',
                                bankName: !isActiveMandPresent ? banksList?.[0]?.bankName : '',
                                startDate: dayjs().format("YYYY-MM-DD"),
                                endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                                acctType: ""
                            },
                            active: {
                                mandateId: isActiveMandPresent ? firstActiveMandate?.mandateId : '',
                            },
                            freshMandatePayload: !isActiveMandPresent ? {
                                amount: isComingFromIndFund ? sipAmount : '100000',
                                actype: !isActiveMandPresent ? banksList?.[0]?.bankAccountType : '',
                                mandateType: "N",
                                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                                ifscCode: !isActiveMandPresent ? banksList?.[0]?.ifscCode : '',
                                accountNo: !isActiveMandPresent ? banksList?.[0]?.bankAccountNumber : '',
                                bankName: !isActiveMandPresent ? banksList?.[0]?.bankName : '',
                                portfolioId: selectedPortfolio?.value,
                                startDate: dayjs().format("MM/DD/YYYY"),
                                endDate: dayjs().add(40, 'year').subtract(1, 'month').format("MM/DD/YYYY"),
                            } : {},
                            sipEndDate: '',
                            // curMandateStatus: '',
                            // mandateCreationDate: '',
                        },
                        lumpsum: {
                            lumpAmount: '50000',
                            lumpsumFolio: item?.folios?.availableFolios[0] || '',
                        },
                        lumpsumSip: {
                            lumpSumAmount: '',
                            sipAmount: '',
                            periods: item?.frequencies?.filter((freq) => freq.transactionType === 'SIP')[0]?.frequency || '',
                            installments: '',
                            sipDate: '',
                            mandate: activeMandateList[0]?.mandateId || '',
                            sipFolio: item?.folios?.availableFolios[0] || '',
                            firstOrder: ''
                        },
                        activeTab: 'Lumpsum',
                        schemeId: item?.schemeId,
                        mandate: activeMandateList,
                        folio: addedFolio?.[i],
                    }
                })

                const currentForm = [...formRef.current?.values.fund]
                const newFrom = [...formInitial]

                const getSchemeId = (item: any) => item?.map((obj: any) => obj.schemeId)

                const currentSchemeId = getSchemeId([...currentForm])
                const newSchemeId = getSchemeId([...newFrom])

                const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.schemeId))
                const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.schemeId))

                formRef.current?.resetForm({
                    values: {
                        fund: [...filteredCurrentForm, ...filteredNewData],
                        ...((
                            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                            isRMLikeRole(role) &&
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            documents: formRef.current?.values?.documents ?? []
                        } : {}),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
                        } : {})
                    }
                })
            }
        } catch (err) {
            console.log('error', err)
        } finally {
            setIsLoading(false)
        }

        // try {
        //     setIsLoading(true);
        //     const payload = {
        //         schemeIds: Object.values(schemes)?.map((item: any) => item?.scheme ? item?.scheme : item),
        //         portfolioId: selectedPortfolio?.value,
        //         clientCode: clientCode,
        //         rmId: `${investorRmId}`,
        //         schemeDetails: Object.values(schemes)?.map((obj: any) => ({
        //             scheme_id: obj?.scheme ?? "",
        //             isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
        //         }))
        //     }

        //     const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown
        //     setDetails(res as GETINVESTMENTDETAILTYPE);
        //     const formInitial = [...(res as GETINVESTMENTDETAILTYPE).investmentDetails].map((item, i) => {
        //         return {
        //             ...item,
        //             sip: {
        //                 sipamount: '',
        //                 periods: item?.frequencies?.filter((freq) => freq.transactionType === 'SIP')[0]?.frequency || '',
        //                 installments: '',
        //                 sipDate: '',
        //                 mandate: activeMandateList[0]?.mandateId || '',
        //                 sipFolio: item?.folios?.availableFolios[0] || '',
        //             },
        //             lumpsum: {
        //                 lumpAmount: '',
        //                 lumpsumFolio: item?.folios?.availableFolios[0] || '',
        //             },
        //             activeTab: 'Lumpsum',
        //             schemeId: item?.schemeId,
        //             mandate: activeMandateList,
        //             folio: addedFolio?.[i],
        //         }
        //     })
        //     if (isInvestMore) {
        //         const currentForm = [...formRef.current?.values.fund]
        //         const newFrom = [...formInitial]

        //         const getId = (item: any) => item?.map((obj: any) => obj.folio.id)

        //         const currentSchemeId = getId([...currentForm])
        //         const newSchemeId = getId([...newFrom])

        //         const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.folio.id))
        //         const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.folio.id))

        //         formRef.current?.resetForm({
        //             values: {
        //                 fund: [...filteredCurrentForm, ...filteredNewData],
        //                 ...((
        //                     ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
        //                     isRMLikeRole(role) &&
        //                     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        //                     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        //                 ) ? {
        //                     documents: formRef.current?.values?.documents ?? []
        //                 } : {}),
        //                 ...((
        //                     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        //                     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        //                 ) ? {
        //                     bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
        //                 } : {})
        //             }
        //         })

        //     } else {
        //         const currentForm = [...formRef.current?.values.fund]
        //         const newFrom = [...formInitial]

        //         const getSchemeId = (item: any) => item?.map((obj: any) => obj.schemeId)

        //         const currentSchemeId = getSchemeId([...currentForm])
        //         const newSchemeId = getSchemeId([...newFrom])

        //         const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.schemeId))
        //         const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.schemeId))

        //         formRef.current?.resetForm({
        //             values: {
        //                 fund: [...filteredCurrentForm, ...filteredNewData],
        //                 ...((
        //                     ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
        //                     isRMLikeRole(role) &&
        //                     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        //                     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        //                 ) ? {
        //                     documents: formRef.current?.values?.documents ?? []
        //                 } : {}),
        //                 ...((
        //                     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        //                     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        //                 ) ? {
        //                     bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
        //                 } : {})
        //             }
        //         })

        //     }

        //     // setIsLoading(false);
        // } catch (err) {
        //     console.log('error', err)
        // } finally {
        //     setIsLoading(false)
        // }
    };

    const handleAddMoreChangeRadion = (data: any) => {
        setRadioValue(((pre: any) => {

            const remining = pre.filter((item: any) => (item?.scheme || item) === data.scheme)

            if (pre.length >= MAX_SCHEMES_SELECTED && !remining.length) {
                setWarning(true)
                return pre
            }
            if (remining.length === 0) {
                return [...pre, data]
            } else if (remining.length > 0) {
                return pre.filter((item: any) => (item?.scheme || item) !== data.scheme)
            }
        }));
    };

    const handleProceed = () => {
        const data = selectAllHoldingsInfo.map(item => ({
            ...item,
            folioId: item.folioNo,
            scheme: item.schemeId,
            id: item.id,
            marketValue: item.marketValue,
            investedValue: item.investedValue,
            isReinvestment: item?.isReinvest
        }))

        const checkedIds = data.map((obj) => obj.scheme)

        const folioData = data.map((obj) => ({
            folioId: obj.folioId,
            schemeId: obj.scheme,
            id: obj.id,
            marketValue: obj.marketValue,
            investedValue: obj.investedValue
        }))

        dispatch(setSelectedHoldingsIds([...[]]))
        dispatch(setCheckedHoldingSchemes([...checkedIds]))
        // if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {
        // history.replace({
        //     state: ({
        //         clientCode,
        //         selectedSchemes: [...data],
        //         folio: folioData
        //     })
        // })

        // } 
        // else {

        //     history.replace({ state: ({ selectedSchemes: [...data], clientCode }) })
        // }
        setOpen(false)

        addFunds([...data], folioData)
    }

    const handleDocumentUploadDialogOpen = () => {
        setDocumentUploadDialogVisible(true)
    }

    const handleDocumentUploadDialogClose = () => {
        setDocumentUploadDialogVisible(false)
    }

    const handleDocumentUploadErrorDialogClose = () => {
        setDocumentUploadErrorDialogVisible(false)
    }

    const onDisclaimerCheck = () => {
        setDisclaimerChecked(!disclaimerChecked);
    }

    const handleSelectBankAccount = async (event: SelectChangeEvent<any>) => {
        try {
            if (!formRef.current) return

            setBankBalanceObjLoading(true)

            const { setFieldValue } = formRef.current ?? {}

            setFieldValue('bankAccountNumber', event.target.value);

            setBankBalanceObj({} as GetBankBalanceResponseBody)

            const response = await (dispatch(getBankBalance({
                investorBankAccount: event.target.value,
                clientCode: `${clientCode ?? ""}`,
                investorIfscCode: (bankAccountList?.bankDetails ?? [])?.find((item: any) => item?.bankAccNo === event.target.value)?.ifscCode ?? ""
            })) as unknown as Promise<GetBankBalanceResponseBody>);

            if (!response?.isSuccess) {
                dispatch(showError(response?.message ?? "No Data Available"))
            }

            setBankBalanceObj(response)
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setBankBalanceObjLoading(false)
        }
    }

    const mfTxnStatus = userDetails?.application?.bseClientActivationStatus?.toLowerCase() !== 'active'


    let successMessage = ""

    if (orderType === 'recomment') {
        successMessage = "Your Recommendation is sent successfully to the Investor."
    } else {
        if (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD && selectedPortfolioObj?.portfolioAccountType) {
            if (isRMLikeRole(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["POA"]) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} sent to the checker for approval.`
            }
            if (isRMLikeRole(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["EXY"]
            ) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} successfully sent to the investor for approval. Once authorized and approved the order will be placed.`
            }
        } else {
            successMessage = "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."
        }

    }

    const isMinor = isOnboardingTypeMinor(userDetails?.application?.onboardingType || '');
    const investorName = isMinor ? `${userDetails?.application?.applicants?.[0]?.minorFirstName} ${userDetails?.application?.applicants?.[0]?.minorLastName}` : userDetails?.name;

    return (
        <>
            <BreadCrum array={isRMLikeRole(role) ? rmRouterPath : investorRouterPath} />
            <Typography variant="h1" color={palette.text.primary} fontSize={{ sm: '16px', xs: '16px', md: '24px', lg: '24px' }} mt={2}>
                {pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Invest More" : 'Investment Details'}
            </Typography>
            <Formik
                innerRef={formRef}
                enableReinitialize
                // validateOnChange={false}
                initialValues={formInitialData}
                validationSchema={investmentDetailsSchema}
                onSubmit={newHandleSubmit}>
                {(formik) => {
                    const totalSelected = formRef.current?.values.fund.reduce((sum: any, f: any) => {
                        const tab = f?.activeTab;
                        const sip = parseFloat(f?.sip?.sipamount ?? '0') || 0;
                        const lump = parseFloat(f?.lumpsum?.lumpAmount ?? '0') || 0;
                        const add = tab === 'SIP' ? sip : tab === 'Lumpsum' ? lump : 0;
                        return sum + add;
                    }, 0);

                    const pretty = toINR({ value: totalSelected, locale, currencyCode });
                    const displayTotalAmount = pretty.length > 16
                        ? formatCurrency({ value: totalSelected, locale, currencyCode })
                        : pretty;
                    return (
                        <>
                            <Box component="form" onSubmit={formik.handleSubmit}>
                                <Grid container marginTop={2} spacing={2}>
                                    <Grid item lg={8} md={12} sm={12} xs={12} sx={{ display: 'flex', rowGap: '25px', flexDirection: 'column' }}>
                                        <>
                                            <FieldArray
                                                name='fund'
                                                render={(arrayhelper) => {
                                                    // return ((details?.investmentDetails || [...selectedSchemes.map((item: any) => '')])?.map((data, index) => (
                                                    //     <Card key={index} {...{ isLoading, id: index, data, arrayhelper, handleDelete, clientCode, activeMandateList, folio: folio as any, selectedSchemes: selectedSchemes?.map((item: any) => item?.scheme ? item?.scheme : item) }} />
                                                    // ))
                                                    // )
                                                    return (formik.values.fund)?.map((_data: FormikValues, index: number) => (
                                                        <Card
                                                            key={index}
                                                            {...{ isLoading, id: index, arrayhelper, handleDelete, clientCode, activeMandateList, folio: folio as any, selectedSchemes: selectedSchemes?.map((item: any) => item?.scheme ? item?.scheme : item), isSubmitting: apiLoading, bankAccountList, isBankBalanceObjLoading, mandatesListRes, isComingFromIndFund, banksList }}
                                                        />
                                                    ))
                                                }
                                                }
                                            />
                                            {selectedSchemes.length < MAX_SCHEMES_SELECTED && (
                                                <Box
                                                    component={'div'}
                                                    sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                    {
                                                        isLoading ?
                                                            <Skeleton variant="rectangular" width={200} height={30} /> :
                                                            !isComingFromIndFund && (
                                                                <Hidden only={'xs'}>
                                                                    <Button
                                                                        variant="contained"
                                                                        onClick={() => setOpen(true)}
                                                                        sx={{
                                                                            gap: '10px',
                                                                            padding: '10px 15px',
                                                                            '&:disabled': {
                                                                                opacity: 0.5
                                                                            }
                                                                        }}
                                                                        disabled={isBankBalanceObjLoading || isComingFromIndFund}
                                                                    >
                                                                        <BluePlusIcon fill={palette.common.white} />
                                                                        <Typography
                                                                            variant="body_500"
                                                                            color={palette.common.white}
                                                                        >
                                                                            {pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Add More Holding" : "Add More Funds"}
                                                                        </Typography>
                                                                    </Button>
                                                                </Hidden>
                                                            )
                                                    }
                                                    <Hidden smUp={true}>
                                                        {isLoading ?
                                                            <Skeleton variant="rectangular" width={200} height={30} /> :
                                                            <Button
                                                                variant="contained"
                                                                onClick={() => setOpen(true)}
                                                                sx={{
                                                                    gap: '10px',
                                                                    padding: '10px 15px',
                                                                    '&:disabled': {
                                                                        opacity: 0.5
                                                                    }
                                                                }}
                                                                disabled={isBankBalanceObjLoading || isComingFromIndFund}
                                                            >
                                                                <BluePlusIcon fill={palette.common.white} />
                                                                <Typography
                                                                    variant="body_500"
                                                                    color={palette.common.white}
                                                                >
                                                                    {pathname.split('/')[(pathname.split('/').length - 1)] === 'invest-more' ? 'Add More Holding' : 'Add More Funds'}
                                                                </Typography>
                                                            </Button>
                                                        }
                                                    </Hidden>
                                                </Box>
                                            )}
                                        </>
                                    </Grid>
                                    <Grid item lg={4} md={12} sx={{ width: '100%' }}>
                                        {(
                                            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                            isRMLikeRole(role) &&
                                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                        ) && (
                                                <Box
                                                    sx={{
                                                        background: palette.background.paper,
                                                        padding: '20px',
                                                        borderRadius: '20px',
                                                        marginBottom: "20px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        flexDirection: "column"
                                                    }}
                                                    boxShadow={1}
                                                >
                                                    <Typography
                                                        variant="body_500"
                                                        sx={{
                                                            lineHeight: "20px",
                                                            letterSpacing: "0.02px",
                                                            color: `${palette.text.secondary}B2`,
                                                        }}
                                                    >
                                                        You can add minimum 1 attachment and maximum 5 attachments
                                                    </Typography>
                                                    <Typography
                                                        variant='body_400'
                                                        sx={{
                                                            color: palette.text.primary,
                                                            alignSelf: "flex-start",
                                                            marginTop: "10px"
                                                        }}
                                                    >
                                                        Documents Uploaded: {
                                                            formik?.values?.documents?.filter((obj: {
                                                                documentId: string;
                                                                documentType: string;
                                                            }) => obj.documentId !== "" && obj.documentType !== "")?.length ?? "0"
                                                        }
                                                    </Typography>
                                                    <Button
                                                        sx={{
                                                            ...typography.body_500,
                                                            color: palette.primary[500],
                                                            padding: "5px",
                                                            fontWeight: 600,
                                                            marginTop: "15px"
                                                        }}
                                                        onClick={handleDocumentUploadDialogOpen}
                                                        disabled={isLoading || apiLoading || isBankBalanceObjLoading}
                                                    >
                                                        Upload Documents
                                                    </Button>
                                                </Box>
                                            )}
                                        {(
                                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                        ) && (
                                                <Box
                                                    sx={{
                                                        background: palette.background.paper,
                                                        padding: '20px',
                                                        borderRadius: '20px',
                                                        marginBottom: "20px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        flexDirection: "column",
                                                        rowGap: "15px"
                                                    }}
                                                    boxShadow={1}
                                                >
                                                    <Box sx={{ width: "100%" }}>
                                                        <CustomeBlueDropDown
                                                            isLoading={isLoading || isBankBalanceObjLoading}
                                                            label='Select Bank Account'
                                                            disabled={apiLoading}
                                                            name="bankAccountNumber"
                                                            list={(bankAccountList?.bankDetails ?? [])?.map(
                                                                (obj: BankDetails) => ({ label: `${obj?.bankAccNo} ${obj?.bankname}`, value: obj?.bankAccNo })
                                                            )}
                                                            onChange={handleSelectBankAccount}
                                                        />
                                                    </Box>
                                                    {(!(isLoading || isBankBalanceObjLoading) && (Object.keys(bankBalanceObj ?? {}).length > 0)) && (
                                                        <Typography
                                                            variant='body_500'
                                                            sx={{ color: palette.text.secondary }}
                                                        >
                                                            Available Balance: {toINR({ value: (bankBalanceObj.bankBalance ?? 0), locale, currencyCode })}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            )}
                                        <Box
                                            sx={{
                                                background: palette.background.paper,
                                                padding: { xs: "25px 25px 25px 25px", sm: '25px 30px 30px' },
                                                borderRadius: '20px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '35px',
                                            }}
                                            boxShadow={1}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', maxHeight: '58px' }}>
                                                {userLoading ? (
                                                    <CircularProgress />
                                                ) : (
                                                    <Box sx={(theme: Theme) => (
                                                        {
                                                            backgroundColor: theme.palette.primary[200],
                                                            borderRadius: '50%',
                                                            width: '70px',
                                                            height: '58px',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                        }
                                                    )}>
                                                        <Typography variant="h1" sx={(theme: Theme) => ({
                                                            letterSpacing: '0.02px',
                                                            color: theme.palette.primary[500]
                                                        })}>{getAbbreviatedName(investorName ?? "")}</Typography>
                                                    </Box>
                                                )}
                                                <Box width={'100%'}>
                                                    <Typography variant="h2" color={palette.text.primary} fontSize={{ sm: '18px', xs: '18px', md: '20px', lg: '20px' }}>
                                                        {' '}
                                                        {userLoading ? <Skeleton variant="text" animation="wave" /> : maskInfo(investorName || '')}
                                                    </Typography>
                                                    {userLoading ? (
                                                        <Skeleton variant="text" animation="wave" />
                                                    ) : (
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <Typography variant="body_500" color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>
                                                                {isMinor ? "Minor" : userDetails?.status}
                                                            </Typography>
                                                            {/* <Box sx={{ borderRadius: '50%', width: '5px', height: '5px', background: palette.text.secondary }} />
                                                        <Typography variant="body_500" color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>
                                                            {userDetails?.accountType ?? "-"}
                                                        </Typography> */}
                                                            <Box sx={{ borderRadius: '50%', width: '5px', height: '5px', background: palette.text.secondary }} />
                                                            <Typography variant="subtitle_500" color={palette.text.secondary}>
                                                                {clientCode}
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                            {/* {role === USER_ROLES.INVESTOR && (
                                            <Box sx={{ width: '100%', mt: 3 }}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
                                                        control={
                                                            <Checkbox
                                                                size="medium"
                                                                disableRipple
                                                                checkedIcon={<CheckIcon />}
                                                                icon={<UnCheckIcon />}
                                                                sx={{
                                                                    padding: 0,
                                                                    '&:hover': {
                                                                        backgroundColor: 'transparent',
                                                                    },
                                                                }}

                                                                onChange={() => setIsTxnDialog(true)}
                                                                checked={disclaimerChecked}
                                                            />}
                                                        label={<TransactionsDisclaimer disclaimerChecked={disclaimerChecked} setDisclaimerChecked={setDisclaimerChecked} />}
                                                    />

                                                </FormGroup>
                                            </Box>
                                        )} */}
                                            {isRMLikeRole(role) &&
                                                <Box width={'100%'}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                        <EmailIcon />
                                                        {userLoading ? (
                                                            <Skeleton variant="text" animation="wave" width={'100%'} />
                                                        ) : (
                                                            <Typography variant="body_500" fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }} color={palette.text.primary}>
                                                                {maskInfo(userDetails?.email || '')}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                        <Phoneicon />
                                                        {userLoading ? (
                                                            <Skeleton variant="text" animation="wave" width={'100%'} />
                                                        ) : (
                                                            <Typography variant="body_500" fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }} color={palette.text.primary}>
                                                                {maskInfo(userDetails?.mobile || '')}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    {/* Disclaimer */}
                                                    {userLoading ? (
                                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                                    ) : (
                                                        <Box sx={{ width: '100%', mt: 3 }}>
                                                            <FormGroup>
                                                                <FormControlLabel
                                                                    sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
                                                                    control={
                                                                        <Checkbox
                                                                            size="medium"
                                                                            disableRipple
                                                                            checkedIcon={<CheckIcon />}
                                                                            icon={<UnCheckIcon />}
                                                                            sx={{
                                                                                padding: 0,
                                                                                '&:hover': {
                                                                                    backgroundColor: 'transparent',
                                                                                },
                                                                                '&.Mui-focusVisible': {
                                                                                    outline: '2px solid',
                                                                                    outlineColor: 'primary.500',
                                                                                    outlineOffset: '-2px',
                                                                                    borderRadius: '4px',
                                                                                },
                                                                            }}
                                                                            inputProps={{ 'aria-label': 'I agree to the terms and conditions' }}
                                                                            onChange={() => setIsTxnDialog(true)}
                                                                            checked={disclaimerChecked}
                                                                        />}
                                                                    label={<TransactionsDisclaimer disclaimerChecked={disclaimerChecked} setDisclaimerChecked={setDisclaimerChecked} />}
                                                                />

                                                            </FormGroup>
                                                        </Box>
                                                    )}
                                                </Box>
                                            }
                                            <Divider />
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: { lg: 'column', md: 'column', sm: 'row-reverse', xs: 'row-reverse' },
                                                    gap: '10px',
                                                    justifyContent: { lg: 'center', md: 'center', sm: 'space-between', xs: 'space-between' },
                                                    alignItems: 'center',
                                                }}>
                                                {isLoading ? (
                                                    <Skeleton variant="text" animation="wave" width={100} />
                                                ) : (
                                                    <Typography variant="h1" fontSize={{ sm: '20px', xs: '20px', md: '32px', lg: '32px' }} color={palette.text.primary}>
                                                        {/* {toINR({
                                                        value: formik.values.fund.reduce((pre: any, curr: any) => pre + (curr?.sip?.sipamount ? parseFloat(curr?.sip?.sipamount || '0') : parseFloat(curr?.lumpsum?.lumpAmount || '0')), 0),
                                                        locale,
                                                        currencyCode
                                                    }).length > 16 ? formatCurrency({
                                                        value: formik.values.fund.reduce((pre: any, curr: any) => pre + (curr?.sip?.sipamount ? parseFloat(curr?.sip?.sipamount || '0') :
                                                            parseFloat(curr?.lumpsum?.lumpAmount || '0')), 0),
                                                        locale,
                                                        currencyCode
                                                    }) :
                                                        toINR({
                                                            value: formik.values.fund.reduce((pre: any, curr: any) => pre + (curr?.sip?.sipamount ? parseFloat(curr?.sip?.sipamount || '0') : parseFloat(curr?.lumpsum?.lumpAmount || '0')), 0),
                                                            locale,
                                                            currencyCode
                                                        })} */}
                                                        {displayTotalAmount}
                                                    </Typography>
                                                )}
                                                {isLoading ? (
                                                    <Skeleton variant="text" animation="wave" width={100} />
                                                ) :
                                                    <Typography variant="body_500" color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>
                                                        Total Amount
                                                    </Typography>
                                                }
                                            </Box>
                                            {isRMLikeRole(role) && (!isLoading) && mfTxnStatus && (
                                                <Typography variant="overline_600" sx={(theme: Theme) => ({ mt: 2, color: theme.palette.error[500] })} >
                                                    You are not allowed to place any transactions as your transaction status is still not active.
                                                </Typography>
                                            )}
                                            {role === USER_ROLES.INVESTOR && (
                                                <>
                                                    {/* Disclaimer */}
                                                    {userLoading ? (
                                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                                    ) : (
                                                        <Box sx={{ width: '100%', mt: 3 }}>
                                                            <FormGroup>
                                                                <FormControlLabel
                                                                    sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
                                                                    control={
                                                                        <Checkbox
                                                                            size="medium"
                                                                            disableRipple
                                                                            checkedIcon={<CheckIcon />}
                                                                            icon={<UnCheckIcon />}
                                                                            sx={{
                                                                                padding: 0,
                                                                                '&:hover': {
                                                                                    backgroundColor: 'transparent',
                                                                                },
                                                                                '&.Mui-focusVisible': {
                                                                                    outline: '2px solid',
                                                                                    outlineColor: 'primary.500',
                                                                                    outlineOffset: '-2px',
                                                                                    borderRadius: '4px',
                                                                                },
                                                                            }}
                                                                            inputProps={{ 'aria-label': 'I agree to the terms and conditions' }}
                                                                            onChange={() => setIsTxnDialog(true)}
                                                                            checked={disclaimerChecked}
                                                                        />}
                                                                    label={<TransactionsDisclaimer disclaimerChecked={disclaimerChecked} setDisclaimerChecked={setDisclaimerChecked} />}
                                                                />

                                                            </FormGroup>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                            <Box sx={{ display: 'flex', gap: '15px', flexDirection: 'row' }}>
                                                {isRMLikeRole(role) &&
                                                    <>
                                                        <CustomeButton
                                                            lookType={'outlined'}
                                                            btnText={'Recommend'}
                                                            isLoading={apiLoading || riskPflChkLoading}
                                                            disabled={
                                                                // (details?.investmentDetails?.length || 0) === 0 ||
                                                                ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                                isLoading ||
                                                                isBankBalanceObjLoading ||
                                                                (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                    isRMLikeRole(role) &&
                                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                                                )
                                                            }
                                                            onClick={async () => {
                                                                setOrderType('recomment')
                                                                // formik.handleSubmit()
                                                            }}
                                                        />
                                                        <CustomeButton lookType={'contained'} btnText={'Place Order'}
                                                            isLoading={apiLoading || riskPflChkLoading}
                                                            disabled={
                                                                // (details?.investmentDetails?.length || 0) === 0 ||
                                                                ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                                isLoading ||
                                                                isBankBalanceObjLoading ||
                                                                (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                    isRMLikeRole(role) &&
                                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                    MPOWER_ACCOUNT_TYPE_MASTER["ADV"]
                                                                ) || !disclaimerChecked || mfTxnStatus
                                                            }
                                                            // disabled={selectedSchemes.length === 0 || isLoading || riskPflChkLoading}
                                                            onClick={async () => {
                                                                setOrderType('order')
                                                                // formik.handleSubmit()
                                                            }}
                                                        />
                                                    </>
                                                }
                                                {role === USER_ROLES.INVESTOR &&
                                                    <>
                                                        <CustomeButton
                                                            lookType={'outlined'}
                                                            btnText={'Add to Cart'}
                                                            isLoading={apiLoading}
                                                            // (formRef.current?.values?.fund ?? [])
                                                            disabled={
                                                                // (details?.investmentDetails?.length || 0) === 0 ||
                                                                ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                                isLoading ||
                                                                isBankBalanceObjLoading
                                                            }
                                                            // disabled={selectedSchemes.length === 0 || isLoading}
                                                            onClick={async () => {
                                                                setOrderType('investor')
                                                                // formik.handleSubmit()

                                                            }}
                                                        />
                                                        <CustomeButton lookType={'contained'} btnText={'Place Order'}
                                                            isLoading={apiLoading || riskPflChkLoading}
                                                            disabled={
                                                                // (details?.investmentDetails?.length || 0) === 0 ||
                                                                ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                                isLoading ||
                                                                isBankBalanceObjLoading ||
                                                                (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                   isRMLikeRole(role) &&
                                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                    MPOWER_ACCOUNT_TYPE_MASTER["ADV"]
                                                                ) || !disclaimerChecked || mfTxnStatus
                                                            }
                                                            // disabled={selectedSchemes.length === 0 || isLoading || riskPflChkLoading}
                                                            onClick={async () => {
                                                                setOrderType('order')
                                                                // formik.handleSubmit()
                                                            }}
                                                        />
                                                    </>
                                                }
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            {/* Document Upload Dialog Start */}
                            <TransactionsDocumentUpload
                                open={isDocumentUploadDialogVisible}
                                onClose={handleDocumentUploadDialogClose}
                            />
                            {/* Document Upload Dialog End */}

                            {/* Multiple Orders from the same scheme/folio combination Dialog start */}
                            <ConfirmRecomment
                                open={isSameSchemesDialogOpen}
                                setClose={handleSameSchemeDialogClose}
                                title="Confirm!"
                                desc="Multiple Orders with the same scheme/folio combination. Please confirm before proceeding."
                                handleConfirm={handleSameSchemeDialogConfirm}
                            />
                            {/* Multiple Orders from the same scheme/folio combination Dialog end */}
                        </>
                    )
                }}
            </Formik >

            {open &&
                isInvestMore ?
                <HoldingFundMore {...{ open, setOpen, clientCode: clientCode, holdingsData, setHoldingsData, handleProceed, setSchemeAllDetails }} /> :
                <MoreFundsModal {...{ open, setOpen, clientCode: clientCode, handleAddMoreProceed, handleAddMoreChangeRadion, radioValue, setRadioValue, setWarning, warning, setSchemeAllDetails }} />
            }
            <ConfirmRecomment
                isLoading={apiLoading}
                open={confirmRecomment}
                setClose={setConfirmRecomment}
                title={orderType === 'recomment' ? "Confirm Recommendation!" : orderType === 'order' ? "Confirm!" : ''}
                desc={orderType === 'recomment' ? "Are you sure you want to continue with this action ? You can see your old recommendations under recent recommendation tab." : "Are you sure you want to continue with this action ?"}
                handleConfirm={() => orderType === 'recomment' ? handleConfromRecomment() : orderType === 'order' && handleConformOrder()}
            />
            <RiskProfilePopup open={riskProfilePopup} setClose={handleRiskProfilePopup} handleConfirmOrder={handleConformOrder} isLoading={apiLoading} text={riskPopupText} />

            {cartPopup &&
                <AddtoCardPopup open={cartPopup} setClose={setCartPopup} handleSuccess={handleSuccess} />
            }
            <SuccessModal
                open={successModal}
                setClose={setSuccessModal}
                onclick={handleSuccessPopup}
                title="Success!"
                confirmBtnText={"Go to Dashboard"}
                // confirmBtnText={pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Go to Mutual Fund Holding" : 'Go to Mutual Fund Orders'}
                // desc={orderType === 'recomment' ? "Your Recommendation is sent successfully to the Investor." : "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."}
                desc={successMessage ?? ""}
            />
            <FiveSchemeErrorMessage handleCloseFiveSchemesDialog={handleCloseFiveSchemesDialog} isFiveSchemesDialogVisible={isFiveSchemesDialogVisible} />
            <ValidateDialogBox handleValidationDialogClose={handleValidationDialogClose} validationErrorsArray={validationErrorsArray} isValidationDialogVisible={isValidationDialogVisible} />

            {/* Document Upload Error Dialog Start */}
            <Dialog
                aria-labelledby="error-dialog"
                open={isDocumentUploadErrorDialogVisible}
                PaperProps={{
                    sx: {
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: palette.common.white
                    },
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <FailureIcon width="35" height="35" />
                    <Typography
                        variant="h2"
                        sx={{
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: palette.text.primary
                        }}
                    >
                        Error!
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={{
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        }}
                    >
                        Please upload minimum 1 document
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleDocumentUploadErrorDialogClose}
                        sx={{
                            ...typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: palette.primary[500]
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Document Upload Error Dialog End */}

            {/* Transaction Disclaimer Popup */}
            <TransactionsDisclaimerText
                handleDialogClose={() => {
                    setIsTxnDialog(false);
                    setDisclaimerChecked(true);
                }}
                isDialog={isTxnDialog}
            />
        </>
    )
}

export default Transaction
